<div class="lm">

  <!-- ── Left branding panel ── -->
  <div class="lm-left">
    <div class="lm-brand">
      <img src="assets/images/logo-mark.png" alt="Townlee" class="lm-mark" />
      <span class="lm-name">Townlee</span>
    </div>
    <img src="assets/images/logo-mark.png" alt="" class="lm-mark-big" />
    <div class="lm-copy">
      <h2>Your next home is a tap away.</h2>
      <p>Log in to chat with owners, save properties and post your own listing — free.</p>
      <ul class="lm-bullets">
        <li><mat-icon>verified_user</mat-icon>Verified owners only</li>
        <li><mat-icon>savings</mat-icon>Zero brokerage, always</li>
        <li><mat-icon>bookmark_border</mat-icon>Save &amp; track your favourites</li>
      </ul>
    </div>
  </div>

  <!-- ── Right form panel ── -->
  <div class="lm-right">
    <button class="lm-close" (click)="dialogRef.close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>

    <!-- Phone / OTP view (default) -->
    <ng-container *ngIf="view === 'phone'">
      <span class="lm-eyebrow">WELCOME</span>
      <h3 class="lm-title">Log in or sign up</h3>
      <p class="lm-desc">Enter your mobile number and we'll send you a verification code.</p>

      <label class="lm-label">Mobile number</label>
      <div class="lm-phone-row">
        <div class="lm-country">
          <span class="lm-flag">🇮🇳</span>
          <span class="lm-code">+91</span>
        </div>
        <input class="lm-phone-input" type="tel" inputmode="numeric" maxlength="10" placeholder="9876543210"
               [ngModel]="phone" (ngModelChange)="onPhoneInput($event)" />
      </div>

      <div class="lm-err" *ngIf="loginError">{{ loginError }}</div>

      <button class="lm-continue" [disabled]="!phone.trim() || isSubmitting" (click)="continuePhone()">
        {{ isSubmitting ? 'Sending OTP…' : 'Continue' }} <mat-icon>arrow_forward</mat-icon>
      </button>

      <p class="lm-terms">
        By continuing you agree to Townlee's
        <a href="#/legal/terms-of-service" target="_blank">Terms</a> &amp; <a href="#/legal/privacy-policy" target="_blank">Privacy Policy</a>.
      </p>
    </ng-container>

    <!-- OTP verification view -->
    <ng-container *ngIf="view === 'otp'">
      <button class="lm-back" (click)="goBackToPhone()">
        <mat-icon>arrow_back</mat-icon>Back
      </button>

      <span class="lm-eyebrow">VERIFICATION</span>
      <h3 class="lm-title">Enter OTP</h3>
      <p class="lm-desc">We've sent a 6-digit code to <strong>+91 {{ phone }}</strong>.</p>

      <label class="lm-label">Verification code</label>
      <input class="lm-input" type="text" inputmode="numeric" maxlength="6"
             placeholder="• • • • • •" [(ngModel)]="otp" />

      <div class="lm-err" *ngIf="otpError">{{ otpError }}</div>

      <button class="lm-continue" [disabled]="!otp.trim() || isSubmittingOtp"
              (click)="submitOtp()" style="margin-top:22px">
        {{ isSubmittingOtp ? 'Verifying…' : 'Verify' }}
        <mat-icon>arrow_forward</mat-icon>
      </button>

      <p class="lm-terms" style="margin-top:16px">
        Didn't receive the code?
        <a href="#" *ngIf="resendCooldown === 0; else resendWait"
           (click)="$event.preventDefault(); resendOtp()">Resend</a>
        <ng-template #resendWait>Resend in {{ resendCooldown }}s</ng-template>
      </p>
    </ng-container>

    <!-- New-user username/name view -->
    <ng-container *ngIf="view === 'name'">
      <span class="lm-eyebrow">WELCOME</span>
      <h3 class="lm-title">What should we call you?</h3>
      <p class="lm-desc">Enter a username so owners and other users can recognise you.</p>

      <label class="lm-label">Username</label>
      <input class="lm-input" type="text" maxlength="50" placeholder="Enter your username"
             [(ngModel)]="name" />

      <div class="lm-err" *ngIf="nameError">{{ nameError }}</div>

      <button class="lm-continue" [disabled]="!name.trim() || isSubmittingName"
              (click)="submitName()" style="margin-top:22px">
        {{ isSubmittingName ? 'Saving…' : 'Continue' }}
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </ng-container>
  </div>

</div>
